import * as React from 'react';

import type {OutcomeType} from 'nutshell-graphql-types';
import type {SalesAutomationClosedLeadAutomation_followupLeadAutomations as FollowupLeadAutomation} from 'nutshell-graphql-types';

import {StageSingleItemContainer} from '../../card-containers/stage-single-item-container';

import {ClosedLeadFollowupRuleCard} from './closed-lead-followup-rule-card';

type Props = {
    isLoading: boolean;
    errorMessage: string | null | undefined;
    followupLeadAutomations: FollowupLeadAutomation[];
    outcomeType: OutcomeType;
};

export function ClosedLeadFollowupRuleContainer(props: Props) {
    const automation =
        props.followupLeadAutomations && props.followupLeadAutomations.length
            ? props.followupLeadAutomations[0]
            : null;

    return (
        <StageSingleItemContainer
            type='closedLeadFollowupRule'
            isLoading={props.isLoading}
            errorMessage={props.errorMessage}
            hideAddCard={Boolean(
                props.followupLeadAutomations && props.followupLeadAutomations.length
            )}
            parentId={props.outcomeType}
            item={
                automation ? (
                    <ClosedLeadFollowupRuleCard
                        automation={automation}
                        outcomeType={props.outcomeType}
                    />
                ) : null
            }
        />
    );
}
